import { Injectable } from '@angular/core';

@Injectable()
export class DAO {
    public policyNumber: any = '';
    public clientInfo: any;
    public policyDetail: any;
    public loginUserDetail: any;
    public closedPopupModel: ClosedPopupModel = new ClosedPopupModel();
    public reportClaimData: reportClaimModel = new reportClaimModel();
    public claimDetails: any;
    public referenceNumber: string;
    public policyQuotesList: any;
    public reasonDropdown: any = [];
    public agencyCode:any='';
    public insuredName:any='';
    public PriorEffectiveDate = "2021-12-01T00:00:00";
    public showErrorPopup: boolean = false;
    constructor(){

    }

}
export class ClosedPopupModel {
    public cancelReasonCdModal: any;
    public cancelEffectiveDateModal: any;
    public cancelOCP: any;
    public policyNumber: any;
    public policyNumberModal: any;
    public isAcknowledge: any;
    public isShowError: boolean = false;
    public errorMsg: string = '';
    public returnedPremium: string = '';
    public isBPmiAmendment: boolean = false;
}

export class reportClaimModel {
    public Phone: string = "";
    public AlternatePhone: string = "";
    public Email: string = "";
    public DateOfLoss: Date;
    public TypeOfLoss: string = "";
    public LoginFirstName: string = "";
    public LoginLastName: string = "";
    public CauseOfLoss: string = "";
    public TempTypeOfLoss: string = "";
    public SubTypeOfLoss: string = "";
    public isLossProjectAddress: string;
    public DescriptionOfLoss: string = "";
    public Address: string = "";
    public City: string = "";
    public State: string = "";
    public Zip: string;
    public PolicyNumber: string = "";
    public PolicyType: string = "";
    public FirstName: string = "";
    public LastName: string = "";
    public EffectiveDate: Date;
    public ExpirationDate: Date;
    public FileDocumentID: any = [];
    public InsuredName: string = "";
    public ReferenceNumber: string = "";
}